/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_File_SubtitleInputs */

const en_mobile_upload_file_subtitle = /** @type {(inputs: Mobile_Upload_File_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a PDF, EPUB, MOBI, Word, PowerPoint, text, or RTF file`)
};

const es_mobile_upload_file_subtitle = /** @type {(inputs: Mobile_Upload_File_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un PDF, EPUB, MOBI, Word, PowerPoint, texto o archivo RTF`)
};

/**
* | output |
* | --- |
* | "Select a PDF, EPUB, MOBI, Word, PowerPoint, text, or RTF file" |
*
* @param {Mobile_Upload_File_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_file_subtitle = /** @type {((inputs?: Mobile_Upload_File_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_File_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_file_subtitle(inputs)
	return en_mobile_upload_file_subtitle(inputs)
});